"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { EnhancedBreadcrumbs } from "@/components/dashboard/EnhancedBreadcrumbs";
import { DashboardMain } from "@/components/dashboard/DashboardMain";
import { ShellGlobalActions } from "@/components/shell/ShellGlobalActions";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
export default function HubDashboardLayout(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SidebarTrigger className="-ml-1 shrink-0" />;
    t2 = <Separator orientation="vertical" className="mr-2 hidden data-[orientation=vertical]:h-4 sm:block" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <header className="flex h-16 shrink-0 items-center gap-2"><div className="flex min-w-0 flex-1 items-center gap-2 px-4">{t1}{t2}<div className="min-w-0 flex-1 overflow-x-auto [-webkit-overflow-scrolling:touch] [&_ol]:flex-nowrap"><Suspense fallback={<div className="h-4 w-48 animate-pulse rounded bg-muted" />}><EnhancedBreadcrumbs /></Suspense></div></div><ShellGlobalActions className="px-4" creditVariant="inline" /></header>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <div className="flex min-h-0 h-full w-full flex-col">{t3}<DashboardMain overflow="auto">{children}</DashboardMain></div>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}